import { useCallback } from "react";
import useRightSidebar from "hooks/useRightSidebar";
import SidebarInvestigationDetails from "security-app/components/Investigations/Details/SidebarInvestigationDetails";
import { useInvestigationDrawer } from "../contexts";
function useInvestigationPanel() {
  const { openSidebar, closeSidebar } = useRightSidebar();
  const { selectedInvestigationId, setSelectedInvestigationId, clearInvestigation } = useInvestigationDrawer();
  const openInvestigation = useCallback(
    (id) => {
      openSidebar(SidebarInvestigationDetails(id));
    },
    [openSidebar]
  );
  const closeInvestigation = useCallback(() => {
    clearInvestigation();
    closeSidebar();
  }, [clearInvestigation, closeSidebar]);
  const _setSelectedInvestigationId = (id, openInSidebar = false) => {
    setSelectedInvestigationId(id);
    if (openInSidebar) {
      openInvestigation(id);
    }
  };
  return {
    selectedInvestigationId,
    setSelectedInvestigationId: _setSelectedInvestigationId,
    openInvestigation,
    closeInvestigation
  };
}
export default useInvestigationPanel;
